  import { defineComponent, type PropType } from "vue";
  import NumeroObjetCode from '@/extend/controls/numeroObjet/NumeroObjetCode';
  import NumeroObjetLabel from '@/extend/controls/numeroObjet/NumeroObjetLabel';
  import NumeroObjet from '@/extend/classes/NumeroObjet';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeNumeroObjet } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      NumeroObjetCode,
      NumeroObjetLabel,
    },

    props: {
      numeroObjet: {
        type: Object as PropType<NumeroObjet>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
        codeStatus: new FieldStatus(false, false, 0),
        strCode: '',
        labelStatus: new FieldStatus(false, false, 0),
        strLabel: '',
        refNumeroObjet: new NumeroObjet,
        cloneNumeroObjet: new NumeroObjet,
      numeroObjetSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.NUMERO_OBJET,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editNumeroObjet.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editNumeroObjet: {
        get(): NumeroObjet {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.numeroObjet != undefined) {
              if (this.numeroObjet.id == 0) {
                Alerts.debug('CrudNumeroObjet : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneNumeroObjet.id != this.numeroObjet.id && !this.saving) {
                this.handleNumeroObjetChange();
              }
            }
          }
          return this.refNumeroObjet;
        },
        set(value: NumeroObjet) {
          this.refNumeroObjet = value;
        }
      },

      canCreate (): boolean {
        return this.refNumeroObjet.id > 0;
      },

      canDelete (): boolean {
        return this.refNumeroObjet.canDelete && this.refNumeroObjet.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },


      code: {
        get(): string {
          return this.editNumeroObjet.code;
        },
        set(value: string) {
          this.editNumeroObjet.code = value;
          this.fieldUpdated('CODE', value);
        }
      },


      label: {
        get(): string {
          return this.editNumeroObjet.label;
        },
        set(value: string) {
          this.editNumeroObjet.label = value;
          this.fieldUpdated('LABEL', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.numeroObjet.canUpdate && (
        (this.isDisplayed('CODE') && !this.readOnly('CODE')) ||
        (this.isDisplayed('LABEL') && !this.readOnly('LABEL')));
        return !res;
      },

      fields (): string[] {
        return ['CODE', 'LABEL'];
      },
    },

    methods: {
      handleNumeroObjetChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.numeroObjet);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.numeroObjet);
          }
        } else if (!this.inDialog) {
          if (this.cloneNumeroObjet.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.numeroObjet);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.codeStatus != undefined && this.codeStatus.updated) ||
          (this.labelStatus != undefined && this.labelStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.numeroObjet);
        }
      },

      setError (): void {
        const error = this.codeStatus.error ||
        this.labelStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.numeroObjet);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refNumeroObjet.id < 0) {
          storeNumeroObjet.mNumeroObjetDeleted(this.refNumeroObjet.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refNumeroObjet.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveNumeroObjet()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.numeroObjetSaving = false;
          this.createRef(this.refNumeroObjet);
          this.$emit('updated', this.refNumeroObjet);
          if (this.numeroObjet.id > 0) {
            this.$emit('saved', this.refNumeroObjet);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refNumeroObjet.failed) {
          this.saveLoading = false;
            this.numeroObjetSaving = false;
            this.refNumeroObjet.failed = false;
          }
        }
      },

      saveNumeroObjet (): boolean {
        if (!this.refNumeroObjet.compareNumeroObjet(this.cloneNumeroObjet)) {
          if (!this.numeroObjetSaving) {
            this.numeroObjetSaving = true;
          if (this.refNumeroObjet.id > 0) {
            storeNumeroObjet.updateNumeroObjet(this.refNumeroObjet)
              .then((data: NumeroObjet) => {
                if (!data.failed) {
                  this.refNumeroObjet = storeNumeroObjet.getNumeroObjet(data.id);
                  this.cloneNumeroObjet = data.cloneNumeroObjet();
                } else {
                  this.refNumeroObjet.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.numeroObjetSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refNumeroObjet.id <= 0) {
              storeNumeroObjet.createNumeroObjet(this.refNumeroObjet)
                .then((data: NumeroObjet) => {
                  if (!data.failed) {
                    this.refNumeroObjet = storeNumeroObjet.getNumeroObjet(data.id);
                    this.cloneNumeroObjet = data.cloneNumeroObjet();
                  } else {
                this.refNumeroObjet.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.numeroObjetSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refNumeroObjet.id <= 0) {
          storeNumeroObjet.mNumeroObjetDeleted(this.refNumeroObjet.id);
        } else {
          storeNumeroObjet.deleteNumeroObjet(this.refNumeroObjet);
        }
      },

      statusCode (value: FieldStatus): void {
        this.codeStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusLabel (value: FieldStatus): void {
        this.labelStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteNumeroObjet(): void {
        this.$emit('deleteNumeroObjet',  this.numeroObjet);
      },

    addNumeroObjet(): void {
      this.$emit('addNumeroObjet',  this.numeroObjet);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneNumeroObjet != undefined) {
          this.restoring = true;
          this.refNumeroObjet.code = this.cloneNumeroObjet.code;
          this.refNumeroObjet.label = this.cloneNumeroObjet.label;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: NumeroObjet): void {
        this.clearRef();
        this.editNumeroObjet = value;
        this.cloneNumeroObjet = value.cloneNumeroObjet();
        this.codeStatus.clear(value.id);
        this.labelStatus.clear(value.id);
        this.status.clear();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('CODE') && this.$refs.CODE) this.$refs.CODE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LABEL') && this.$refs.LABEL) this.$refs.LABEL.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CODE') && this.isDisplayed('CODE') && this.$refs.CODE && this.$refs.CODE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'LABEL') && this.isDisplayed('LABEL') && this.$refs.LABEL && this.$refs.LABEL.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('CODE') && this.$refs.CODE) this.$refs.CODE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LABEL') && this.$refs.LABEL) this.$refs.LABEL.save();
      },

      getValue (field: string): string {
         if (field == 'CODE') return this.code.toString();
        else  if (field == 'LABEL') return this.label.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
